import { render, staticRenderFns } from "./work_learner_data.vue?vue&type=template&id=03c27638&scoped=true"
import script from "./work_learner_data.vue?vue&type=script&lang=js"
export * from "./work_learner_data.vue?vue&type=script&lang=js"
import style0 from "./work_learner_data.vue?vue&type=style&index=0&id=03c27638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c27638",
  null
  
)

export default component.exports